import { gql } from "@apollo/client";
import { QueryItemFragment } from "src/gql/codegen/graphql";

export const queryItemGqlFragment = gql`
  fragment QueryItem on queries {
    id
    name
    created_at
    updated_at
    tags
    matview_id
    user {
      id
      name
      profile_image_url
    }
    team {
      id
      handle
      profile_image_url
    }
    is_private

    query_favorite_count_all @include(if: $include_favs_all_time) {
      favorite_count
    }
    query_favorite_count_last_24h @include(if: $include_favs_last_24h) {
      favorite_count
    }
    query_favorite_count_last_7d @include(if: $include_favs_last_7d) {
      favorite_count
    }
    query_favorite_count_last_30d @include(if: $include_favs_last_30d) {
      favorite_count
    }
  }
`;

export interface QueryType {
  id: number;
  name: string;
  created_at: string;
  updated_at: string;
  tags: string[];
  owner: {
    type: "user" | "team";
    id: number;
    handle: string;
    profile_image_url?: string;
  };
  matview_id?: string;
  is_private: boolean;
  favoriteCount: number;
}

export function toQueryType(query: QueryItemFragment): QueryType {
  return {
    id: query.id,
    name: query.name ?? "",
    created_at: query.created_at,
    updated_at: query.updated_at,
    tags: query.tags ?? [],
    owner: query.team
      ? {
          type: "team",
          handle: query.team.handle,
          id: query.team.id,
          profile_image_url: query.team.profile_image_url ?? undefined,
        }
      : {
          type: "user",
          handle: query.user?.name ?? "",
          id: query.user!.id,
          profile_image_url: query.user?.profile_image_url ?? undefined,
        },
    is_private: query.is_private,
    matview_id: query.matview_id ?? undefined,
    favoriteCount:
      query.query_favorite_count_all?.favorite_count ??
      query.query_favorite_count_last_24h?.favorite_count ??
      query.query_favorite_count_last_7d?.favorite_count ??
      query.query_favorite_count_last_30d?.favorite_count ??
      0,
  };
}
